export interface HotItem {
  id: number;
  rank: number;
  tag: string;
  title: string;
  heat: string;
  trend: "up" | "down" | "flat";
  summary: string;
  tags: string[];
}

export interface TimelineNode {
  date: string;
  title: string;
  desc: string;
}

export interface TimelineCase {
  id: number;
  name: string;
  status: string;
  tags: string[];
  hot: string;
  desc: string;
  nodes: TimelineNode[];
}

export interface ReviewItem {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  meta: string;
  reads: string;
  img: string;
}

export interface Channel {
  id: number;
  name: string;
  desc: string;
  count: string;
  icon: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface RumorItem {
  id: number;
  tag: string;
  title: string;
  time: string;
}

export const hotList: HotItem[] = [
  {
    id: 1,
    rank: 1,
    tag: "娱乐",
    title: "头部综艺导师换人风波：从官宣到回应的完整时间线",
    heat: "1842.6万热度",
    trend: "up",
    summary: "节目组凌晨官宣阵容变动，艺人工作室三度发声，粉丝与制作方就合同细节各执一词，我们按小时还原每个关键节点。",
    tags: ["综艺", "节目组", "合同"],
  },
  {
    id: 2,
    rank: 2,
    tag: "商业",
    title: "某消费品牌“联名翻车”复盘：一条宣传片引发的舆论地震",
    heat: "1377.2万热度",
    trend: "up",
    summary: "从创意上线到全网争议再到公开致歉，短短 72 小时内品牌策略为何接连失守？细节汇总帮你理清公关失效的全链条。",
    tags: ["联名", "公关", "舆情"],
  },
  {
    id: 3,
    rank: 3,
    tag: "娱乐圈",
    title: "顶流艺人口碑逆转始末：路透、声明与饭圈反应的博弈",
    heat: "958.4万热度",
    trend: "flat",
    summary: "一段未消音视频引发连锁反应，经纪人声明措辞反复，这一场舆论攻防的来龙去脉与关键细节，一次讲清。",
    tags: ["艺人", "声明", "路透"],
  },
  {
    id: 4,
    rank: 4,
    tag: "科技",
    title: "新机发布前后“跑分争议”时间线：参数还是体验之争？",
    heat: "721.9万热度",
    trend: "down",
    summary: "发布会后官方数据与实际体验差距被网友逐帧对比，厂商回应口径变化，技术营销边界讨论持续发酵。",
    tags: ["数码", "跑分", "营销"],
  },
  {
    id: 5,
    rank: 5,
    tag: "文化",
    title: "影视 IP 改编风波梳理：原著粉与剧方的一场拉锯",
    heat: "506.3万热度",
    trend: "up",
    summary: "从选角公布到预告片登场，改编尺度与粉丝期待的落差贯穿全程，各方诉求与回应节点逐一还原。",
    tags: ["影视", "IP", "改编"],
  },
];

export const timelineCases: TimelineCase[] = [
  {
    id: 1,
    name: "案例档案 · 一场联名的舆论风暴",
    status: "复盘完成",
    tags: ["商业", "联名", "公关"],
    hot: "热点事件",
    desc: "以真实舆情事件结构为原型，演示今日看瓜如何把碎片信息编织成可回溯的完整脉络。",
    nodes: [
      { date: "周一 09:20", title: "宣传片上线", desc: "品牌官博发布系列宣传片，评论区出现零星质疑。" },
      { date: "周一 22:00", title: "争议发酵", desc: "网友逐帧解读并汇总细节，多个话题冲上热搜。" },
      { date: "周二 14:10", title: "首度回应", desc: "品牌方发文称“创作初衷被曲解”，未删片。" },
      { date: "周三 11:35", title: "事态升级", desc: "合作方相继表态，舆情进入第二轮讨论。" },
      { date: "周四 08:00", title: "公开致歉", desc: "品牌方发布致歉信并下架物料，事件进入收尾。" },
    ],
  },
  {
    id: 2,
    name: "案例档案 · 一次综艺换人争议",
    status: "复盘完成",
    tags: ["娱乐", "综艺", "节目组"],
    hot: "近期热议",
    desc: "把艺人工作室、制作方与粉丝的多方发声按时序铺开，快速看清谁在何时说了什么。",
    nodes: [
      { date: "周五 23:40", title: "阵容变动官宣", desc: "节目组深夜公告导师更换，措辞含糊。" },
      { date: "周六 01:15", title: "工作室发声", desc: "艺人方称“因档期冲突退出”，补充说明行程。" },
      { date: "周六 12:00", title: "舆论分歧", desc: "粉丝晒出聊天截图，制作方合同细节被讨论。" },
      { date: "周日 10:30", title: "再度回应", desc: "官方发布完整说明，事件热度逐步回落。" },
    ],
  },
];

export const reviewItems: ReviewItem[] = [
  {
    id: 1,
    category: "深度复盘",
    title: "一场热搜的 24 小时：事件是怎么“发酵”起来的？",
    excerpt: "从首发贴到全网传播，我们拆解舆论事件的标准路径，帮你建立一套看懂热点的底层框架。",
    meta: "方法论",
    reads: "12.8万阅读",
    img: "https://readdy.ai/api/search-image?query=Editorial%20warm%20minimal%20abstract%20orange%20peach%20gradient%20with%20soft%20curves%20and%20subtle%20grain%2C%20magazine%20style%20cover%20art&width=800&height=520&seq=review-cover-1&orientation=landscape",
  },
  {
    id: 2,
    category: "细节汇总",
    title: "看图说话：如何从一张路透里读出隐藏信息",
    excerpt: "时间、场景、人物关系，每个细节都在说话。我们总结 6 个看透路透的实用视角。",
    meta: "技巧",
    reads: "9.1万阅读",
    img: "https://readdy.ai/api/search-image?query=Warm%20minimal%20abstract%20terracotta%20clay%20waves%20with%20gentle%20light%20and%20soft%20shadows%2C%20editorial%20design%20art&width=800&height=520&seq=review-cover-2&orientation=landscape",
  },
  {
    id: 3,
    category: "来龙去脉",
    title: "“声明体”进化史：公关文案为什么总被吐槽",
    excerpt: "从公告格式到措辞温度，我们把历年典型声明的写法差异与舆论反馈放在一起比对。",
    meta: "观察",
    reads: "7.6万阅读",
    img: "https://readdy.ai/api/search-image?query=Minimal%20warm%20amber%20geometric%20lines%20layers%20abstract%20background%2C%20clean%20editorial%20visual%20style&width=800&height=520&seq=review-cover-3&orientation=landscape",
  },
  {
    id: 4,
    category: "时间线",
    title: "为什么同一件事，粉丝和路人看到的完全不同？",
    excerpt: "信息茧房下的同一事件，往往被讲成两个故事。我们从视角差异切入做了一次完整复盘。",
    meta: "洞察",
    reads: "6.3万阅读",
    img: "https://readdy.ai/api/search-image?query=Soft%20cream%20minimal%20abstract%20with%20two%20overlapping%20warm%20shapes%20and%20negative%20space%2C%20modern%20editorial%20cover&width=800&height=520&seq=review-cover-4&orientation=landscape",
  },
];

export const channels: Channel[] = [
  { id: 1, name: "娱乐瓜田", desc: "艺人动态、综艺现场、影视线索", count: "128 篇复盘", icon: "ri-mic-line" },
  { id: 2, name: "商业动向", desc: "品牌公关、营销翻车、舆情案例", count: "86 篇复盘", icon: "ri-briefcase-line" },
  { id: 3, name: "科技观察", desc: "数码发布、行业争论、数据之辩", count: "64 篇复盘", icon: "ri-cpu-line" },
  { id: 4, name: "文化现象", desc: "影视改编、圈层文化、话题讨论", count: "52 篇复盘", icon: "ri-article-line" },
];

export const faqItems: FaqItem[] = [
  {
    q: "今日看瓜的事件梳理和普通帖子有什么区别？",
    a: "今日看瓜把散落在各平台的信息，按时间顺序整理成一条清晰的时间线，并补充关键细节与来龙去脉。你不用再在多个帖子之间来回切换，一份复盘即可掌握事件全貌。",
  },
  {
    q: "你们的时间线信息来自哪里？",
    a: "我们聚合公开的官方声明、媒体报道与各方公开表态，并标注时间节点与信息源类型。所有复盘仅呈现已公开信息，不编造不存在的事实。",
  },
  {
    q: "更新频率如何？会滞后吗？",
    a: "热门事件原则上按小时跟进关键节点，常规复盘按天更新。你还可以通过订阅，第一时间收到新复盘的推送提醒。",
  },
  {
    q: "事件复盘会保持中立吗？",
    a: "我们尽量区分“已确认信息”与“网友讨论”，对争议细节会标注来源与不确定性，帮助你建立自己的判断，而不是替你做判断。",
  },
  {
    q: "遇到不实消息怎么办？",
    a: "如发现复盘中有信息错误或遗漏关键节点，欢迎通过页面底部表单反馈，我们会复核并修正，保持内容的可追溯。",
  },
];

export const rumorItems: RumorItem[] = [
  { id: 1, tag: "快讯", title: "某剧方就选角争议发布第二份说明，称正重新评估相关安排", time: "2 小时前" },
  { id: 2, tag: "新瓜", title: "科技博主晒出新机实测数据，与官方宣传存在差异引发热议", time: "5 小时前" },
  { id: 3, tag: "跟进", title: "品牌方回应联名质疑后，合作艺人之家同步发表看法", time: "9 小时前" },
  { id: 4, tag: "观察", title: "理性吃瓜指南：三招识别事件里的“节奏带偏”", time: "昨天" },
  { id: 5, tag: "盘点", title: "本周最值得回看的五场事件时间线合集", time: "昨天" },
];